import useMobileView from '@/hooks/useMobileView';
import { twMerge } from 'tailwind-merge';

const CheckoutTerms = ({
  className = '',
  termsUrl,
  description,
  linkLabel,
  floating = false,
  onTermsOpen,
}: {
  className?: string;
  termsUrl: string;
  description: string;
  linkLabel: string;
  floating?: boolean;
  onTermsOpen?: () => void;
}) => {
  const { isMobileView } = useMobileView();

  return (
    <div className={twMerge('text-s text-center', className)}>
      <span
        className="text-fg_secondary text-inherit"
        {...(floating && isMobileView && { style: { fontSize: 10, lineHeight: '12px' } })}>
        {description}{' '}
        <a
          href={termsUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onTermsOpen}
          className="text-fg_link inline text-left text-inherit underline">
          {linkLabel}
        </a>
      </span>
    </div>
  );
};

export default CheckoutTerms;
